'use strict';

module.exports = {
    replaceForbiddenChars: function () {
        $('.no-special-chars').on('change keyup mouseleave', function () {
            var fieldValue = $(this).val();
            fieldValue = fieldValue.replace(/[’´]/g, '\'')
                .replace(/Æ/g, 'AE')
                .replace(/æ/g, 'ae')
                .replace(/Œ/g, 'OE')
                .replace(/œ/g, 'oe')
                .replace(/&/g, 'and')
                .replace(/ᵉ/g, 'e')
                .replace(/ē/g, 'é')
                .replace(/–/g, '-')
                .replace(/[^0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ' \. \-]/g, ''); // eslint-disable-line
            $(this).val(fieldValue);
        });
    },
    replaceForbiddenCharsMessageField: function () {
        $('.no-special-chars-message').on('change keyup mouseleave', function () {
            var fieldValue = $(this).val();
            fieldValue = fieldValue.replace(/[’´]/g, '\'')
                .replace(/Æ/g, 'AE')
                .replace(/æ/g, 'ae')
                .replace(/Œ/g, 'OE')
                .replace(/œ/g, 'oe')
                .replace(/&/g, 'and')
                .replace(/ᵉ/g, 'e')
                .replace(/ē/g, 'é')
                .replace(/–/g, '-')
                .replace(/[^0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ'?!:;,.…\(\) \. \-]/g, ''); // eslint-disable-line
            $(this).val(fieldValue);
        });
    }
};
